import React, { useEffect } from 'react';
import { Drawer, List, ListItem, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AssignmentIcon from '@material-ui/icons/Assignment';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import CollectionsIcon from '@material-ui/icons/Collections';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import SettingsIcon from '@material-ui/icons/Settings';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import { NavLink, useLocation } from 'react-router-dom';
import { grey, primary } from '../../../theme/colors/index';
import { useSidebar } from './SidebarContext';

export const SIDEBAR_WIDTH = 248;
const headerHeight = 100;

const sideMenuItems = [
  {
    title: 'Ordenes',
    icon: <ShoppingCartIcon />,
    path: '/private/promotionoperation',
  },
  {
    title: 'Publicaciones',
    icon: <AssignmentIcon />,
    path: '/private/publications',
  },
  {
    title: 'Gestión Comercial',
    icon: <BusinessCenterIcon />,
    path: '/private/commercial-management',
  },
  {
    title: 'Operaciones',
    icon: <LocalShippingIcon />,
    path: '/private/operations',
  },
  {
    title: 'Configuración',
    icon: <SettingsIcon />,
    path: '/private/configuration',
  },
  {
    title: 'Contenido Visual',
    icon: <CollectionsIcon />,
    path: '/private/visual-content',
  },
];

const navBarStyles = makeStyles(() => ({
  drawerPaper: {
    top: headerHeight,
    width: SIDEBAR_WIDTH,
    height: `calc(100% - ${headerHeight}px)`,
    borderRight: `1px solid ${grey.dividers}`,
    backgroundColor: primary.white,
    overflowX: 'hidden',
  },
  iconContainer: {
    height: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px 12px',
  },
  selectedIcon: {
    textDecoration: 'none',
    height: 44,
    width: '100%',
    color: primary.paleBlueStrong,
    backgroundColor: primary.primaryLight,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingLeft: 16,
    borderRadius: 10,
    fontWeight: 700,
    '& svg': {
      color: primary.paleBlueStrong,
    },
  },
  defaultIcon: {
    textDecoration: 'none',
    height: 44,
    width: '100%',
    color: grey.textPrimary,
    backgroundColor: primary.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingLeft: 16,
    borderRadius: 10,
    '&:hover': {
      backgroundColor: grey.background,
    },
    '& svg': {
      color: grey.medium,
    },
  },
  titleStyle: {
    fontSize: 14,
    paddingLeft: 14,
    color: 'inherit',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
  },
  backdrop: {
    top: headerHeight,
    backgroundColor: 'rgba(0, 0, 0, 0.55)',
  },
}));

const isItemActive = (pathname: string, path: string) =>
  pathname === path || pathname.startsWith(`${path}/`);

export const SideMenu = () => {
  const classes = navBarStyles();
  const location = useLocation();
  const { isOpen, close } = useSidebar();

  useEffect(() => {
    close();
  }, [location.pathname, close]);

  return (
    <Drawer
      anchor="left"
      variant="temporary"
      open={isOpen}
      onClose={close}
      classes={{
        paper: classes.drawerPaper,
      }}
      ModalProps={{
        keepMounted: true,
      }}
      BackdropProps={{
        classes: {
          root: classes.backdrop,
        },
      }}
    >
      <List>
        {sideMenuItems.map((item) => {
          const active = isItemActive(location.pathname, item.path);

          return (
            <ListItem button key={item.path} disableGutters className={classes.iconContainer}>
              <NavLink
                to={item.path}
                className={active ? classes.selectedIcon : classes.defaultIcon}
                onClick={close}
              >
                {item.icon}
                <Typography className={classes.titleStyle}>{item.title}</Typography>
              </NavLink>
            </ListItem>
          );
        })}
      </List>
    </Drawer>
  );
};
